import React from "react";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import Moment from "moment";
import { DownloadShipDetails } from "../Actions/ClientDashboardAPI";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { DownloadAttachment } from "../Actions/AttachmentAPI";
import swal from "sweetalert";
import i18n from "./DropdownLanguage/i18n";

class EquipmentManagementCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }
  renderequipment(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("ShipDetailsScreen.EquipmentDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  renderdownloadequipmentmanual(props) {
    return (
      <Popover id="equip-manual-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("EquipmentManagementScreenContent.DownloadEquipmentManual")}</label>
        </Popover.Content>
      </Popover>
    );
  }

  downloadEquipManual = (item) => {
    const attachmentName = item?.otherAttachmentName ? item?.otherAttachmentName : "";
    const attachmentGuid = item?.otherAttachmentGuid ? item?.otherAttachmentGuid : "";
    if (attachmentName != "") {
      this.props.dispatch(DownloadAttachment(attachmentName, attachmentGuid));
    } else {
      swal("Information!", "There is no attachment to download.", "info");
    }
  };

  render() {
    const { arraylist,currentPage, pageSize, totalRecords, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {arraylist && arraylist.length !== 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !--{t("CommonText.NoItem")}--!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div
                    className={
                      // item.isDeleted
                      "col-sm-10 col-md-11 col-10 m-auto"
                    }
                  >
                    <div className="row px-4">
                      <div className="col-sm-12 mb-2 d-flex align-items-center">
                        <h6
                          className={
                            item.isDeleted
                              ? "resource-list-title m-0 strick"
                              : "resource-list-title m-0"
                          }
                        >
                          {item.equipmentName}{" "}
                        </h6>{" "}
                        <span className={`badge badge-light ${item?.equipmentCategoryTypeName?.toLowerCase() == "addon" ? "add-on-badge-light" : item?.equipmentCategoryTypeName?.toLowerCase() == "adhoc" ? "add-hoc-badge-light" : "mandate-badge-light"} ml-2`}>
                          {/* {index % 2 == 0 ? "Add On" : "Adhoc"} */}
                          {item?.equipmentCategoryTypeName}
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong className={item.isDeleted ? "strick" : ""}>
                            {t("ComplianceandBudgetScreen.Type")} :{" "}
                          </strong>
                          <span
                            className={
                              item.isDeleted
                                ? "italicFont strick"
                                : "italicFont "
                            }
                          >
                            {item.equipmentType}{" "}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span>
                          <strong className={item.isDeleted ? "strick" : ""}>
                            {t("TopPaneContent.Category")} :{" "}
                          </strong>
                          <span
                            className={
                              item.isDeleted
                                ? "italicFont strick"
                                : "italicFont "
                            }
                          >
                            {item.category}{" "}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong className={item.isDeleted ? "strick" : ""}>
                            {t("ShipEquipmentStatusScreen.Make")} {" "}
                          </strong>
                          <strong>:</strong>
                          <span className={item.isDeleted ? "italicFont strick" : "italicFont "}>
                            {item.makeName.length === 0 ? " " : item.makeName.length > 1 ? item.makeName.map((item) => { return item }).join(',' + " ")
                              : item.makeName.map((i) => i.toString())}
                            {" "}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong className={item.isDeleted ? "strick" : ""}>
                            {t("ShipEquipmentStatusScreen.Model")} {" "}
                          </strong>
                          <strong>:</strong>
                          <span className={item.isDeleted ? "italicFont strick" : "italicFont "}>
                            {item.modelName.length === 0 ? " " : item.modelName.length > 1 ? item.modelName.map((item) => { return item }).join(',' + " ")
                              : item.modelName.map((i) => i.toString())}{" "}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span className={`${isArabic ? 'arabic_ship' : ''}`}>
                          <strong className={item.isDeleted ? "strick" : ""}>
                            {t("content.Servicetype")} {" "}
                          </strong>
                          <stron>:</stron>
                         
                        </span>
                        <span className={item.isDeleted ? "italicFont strick" : "italicFont "}>
                            {item.serviceTypeName.length === 0 ? " " : item.serviceTypeName.length > 1 ? item.serviceTypeName.map((item) => { return item }).join(',' + " ")
                              : item.serviceTypeName.map((i) => i.toString())}{" "}
                          </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 mb-1"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong className={item.isDeleted ? "strick" : ""}>
                            {t("ShipEquipmentStatusScreen.Capacity")} / {t("ShipEquipmentStatusScreen.Size")} {" "}
                          </strong>
                          <strong>:</strong>
                          <span
                            className={
                              item.isDeleted
                                ? "italicFont strick"
                                : "italicFont "
                            }
                          >
                            {item.capacity ? item.capacity.toString() : ""}{" "}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  {!item.isDeleted ? (
                    <div className="col-sm-2 col-md-1 col-2 m-auto text-right text-nowrap">
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderequipment()}
                      >
                        <i
                          className="fa fa-eye click mr-2"
                          onClick={() => eyeclick(item)}
                          aria-hidden="true"
                          style={{
                            color: " #1a3464",
                            fontSize: "1.8rem",
                            marginLeft: "-15px",
                          }}
                        ></i>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderdownloadequipmentmanual()}
                      >
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 75 75"
                          xmlns="http://www.w3.org/2000/svg"
                          className="mequipicon-space pointer-cursor"
                          onClick={() => this.downloadEquipManual(item)}
                        >
                          <circle cx="30" cy="30" r="28" fill="#1a3464" />
                          <text
                            x="30"
                            y="34"
                            font-family="Arial, sans-serif"
                            font-size="40"
                            fill="#FFFFFF"
                            text-anchor="middle"
                            dominant-baseline="middle"
                          >
                            M
                          </text>
                        </svg>
                        {/* <i
                          className="fa fa-download click mr-3"
                          aria-hidden="true"
                          onClick={() => this.downloadEquipManual(item)}
                          style={{ color: " #1a3464", fontSize: "1.5rem" }}
                        ></i> */}
                      </OverlayTrigger>
                    </div>
                  )
                    : (
                      <div className="col-sm-2 col-md-1 col-2 m-auto text-right">
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderdownloadequipmentmanual()}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 75 75"
                            xmlns="http://www.w3.org/2000/svg"
                            className="mequipicon-space pointer-cursor"
                            onClick={() => this.downloadEquipManual(item)}
                          >
                            <circle cx="30" cy="30" r="28" fill="#1a3464" />
                            <text
                              x="30"
                              y="34"
                              font-family="Arial, sans-serif"
                              font-size="40"
                              fill="#FFFFFF"
                              text-anchor="middle"
                              dominant-baseline="middle"
                            >
                              M
                            </text>
                          </svg>
                          {/* <i
                            className="fa fa-download click mr-5"
                            aria-hidden="true"
                            onClick={() => this.downloadEquipManual(item)}
                            style={{ color: " #1a3464", fontSize: "1.5rem" }}
                          ></i> */}
                        </OverlayTrigger>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EquipmentManagementCard)));
